// src/lib/deviceLogsError.ts
//
// «Registros del dispositivo»: the server answers a failure with a code and an
// English message. The screen never shows that message: it translates the code.
// LOGS_UNAVAILABLE (the logs cannot be read right now) has its own sentence;
// anything else reads as the generic «could not retrieve the logs».

/** The translation key of the error to show for a failed device-logs request. */
export const deviceLogsErrorKey = (err: unknown): string => {
  const code = (err as { body?: { error?: { code?: unknown } } } | null | undefined)?.body?.error?.code;
  return code === 'LOGS_UNAVAILABLE' ? 'resources.logs.unavailable' : 'resources.logs.seqError';
};
